const { atom } = require("recoil");

export const visionNotificationState = atom({
  key: "visionNotificationState",
  default: "",
});

export const myVisionsForBannerState = atom({
  key: "myVisionsForBannerState",
  default: [],
});

export const myVisionActiveIndex = atom({
  key: "myVisionActiveIndex",
  default: 0,
});

export const visionCardsData = atom({
  key: "visionCardsData",
  default: [],
});

export const searchUserList = atom({
  key: "searchUserListState",
  default: [],
});

export const visionCardNextToken = atom({
  key: "visionCardNextTokenState",
  default: null,
});

export const visionCopySnackBar = atom({
  key: "visionCopySnackBar",
  default: false
});
export const publicVisionCopySnackBar = atom({
  key: "publicVisionCopySnackBar",
  default: false
});

export const reloadBanner = atom({
  key: "reloadBanner",
  default: false
})

export const cardsActiveIndex = atom({
  key: "cardsActiveIndex",
  default: 0
})

export const activePageIndex = atom({
  key: "activePageIndex",
  default: 1
})

export const totalPage = atom({
  key: "totalPage",
  default: 0
})